
import URI from 'urijs';
import { call, takeEvery } from 'redux-saga/effects'

import { Log } from '../../core';
let log = Log.getLogger('MultiSceneForApp.print.sagas.generate');

export const PRINT_GENERATE_REPORT_ACTION_TYPE = 'print/GENERATE_REPORT';

export default function getActions(dispatch) {
    return {
        generateReport: (report, paramsAsJson) => dispatch({
            type: PRINT_GENERATE_REPORT_ACTION_TYPE,
            report, paramsAsJson
        })
    };
}

function getReportServiceUrl(report, paramsAsJson) {
    let uri = new URI(report.reportUrl);
    uri.setSearch('params', paramsAsJson);
    uri.setSearch('output', report.output || 'html');

    if (uri.is('relative')) {
        const uriActualPage = new URI();
        if (uri.toString()[0] === '/') {
            uri.host(uriActualPage.host());
            uri.protocol(uriActualPage.protocol());
        } else {
            uri = URI.joinPaths(uriActualPage, uri);
        }
    }

    return uri.toString();
}

function getReportGet(report, paramsAsJson) {
    const url = getReportServiceUrl(report, paramsAsJson);
    window.open(url, 'report');
}

async function getReportPost(report, paramsAsJson) {
    let body = {};

    const serviceUrl = getReportServiceUrl(report, paramsAsJson);
    const uri = new URI(serviceUrl);
    const search = uri.search(true);
    Object.keys(search).forEach(key => {
        body[key] = (key !== 'params')
            ? search[key]
            : JSON.parse(search[key]);
    })
    uri.search('');
    const url = uri.toString();

    const options = {
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'post',
        body: JSON.stringify(body)
    };

    const data = await (await fetch(url, options)).blob();
    openReportWindow(data, report.output);
}

function openReportWindow(data, reportType) {
    let blobType = (reportType === 'pdf') ? 'application/pdf' : 'text/html';
    let blob = new Blob([data], {type: blobType});
    if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, `${report.id}.${type}`);
    } else {
        let blobUrl = window.URL.createObjectURL(blob);
        window.open(
            blobUrl, 'report', 'width=900,height=700,location=no,toolbar=no,menubar=no,status=no'
        );
    }
}

function* workGenerateReport(action) {
    try {
        const method = action.report.method || 'POST';

        if (method === 'POST') {
            yield call(getReportPost, action.report, action.paramsAsJson);
        } else {
            yield call(getReportGet, action.report, action.paramsAsJson);
        }
    } catch (error) {
        log.error(error);
    }
}

export function* watchGenerateReport() {
    yield takeEvery(PRINT_GENERATE_REPORT_ACTION_TYPE, workGenerateReport);
}
